/* eslint-disable @typescript-eslint/no-var-requires */
import { gate } from 'hub-http/gates';
import { getQuartzConfig } from 'quartz-config/evaluable';
import { jsx as _jsx } from "react/jsx-runtime";
const quartzConfig = getQuartzConfig();

// Keep in sync with breeze-layout's UNSAFE_EXPERIMENTAL_federationConfig.exposes,
// or Breeze fails to load.
const BREEZE_LAYOUT_REMOTE = 'breeze-layout';
const BREEZE_LOADER_COMPONENT = 'BreezeLoader';
function requireRemoteComponentModules() {
  // quartzConfig-only condition keeps these require()s tree-shakeable, so apps
  // that don't render Breeze directly don't bundle the Module Federation
  // runtime.
  if ( /* quartzConfig.type === 'application' && quartzConfig.auth === 'app' && (quartzConfig.breezeAssistantOptions && quartzConfig.breezeAssistantOptions.directRender) !== false */false) {
    const {
      RemoteComponent
    } = require('../framework/RemoteComponent');
    const {
      preloadRemoteComponent
    } = require('../framework/preloadRemoteComponent');
    return {
      RemoteComponent,
      preloadRemoteComponent
    };
  }
  return null;
}
const remoteComponentModules = requireRemoteComponentModules();
const isBreezeDirectRenderUngated = gates => gates.has(gate('BreezeAssistant::DirectRender'));
export function preloadBreezeLoader(gates) {
  if (remoteComponentModules && isBreezeDirectRenderUngated(gates)) {
    remoteComponentModules.preloadRemoteComponent(BREEZE_LAYOUT_REMOTE, BREEZE_LOADER_COMPONENT);
  }
}
export function BreezeLoader({
  gates
}) {
  if (!remoteComponentModules || !isBreezeDirectRenderUngated(gates)) {
    return null;
  }
  const {
    RemoteComponent
  } = remoteComponentModules;
  return /*#__PURE__*/_jsx(RemoteComponent, {
    remote: BREEZE_LAYOUT_REMOTE,
    component: BREEZE_LOADER_COMPONENT
  });
}